/** Phase F (kaohsiung package): Kaohsiung. Lines marked “English practice” stay in English in every locale. */
export const enKaohsiung = {
  kaohsiung: {
    mapNames: { kaohsiung: 'Kaohsiung' },
    zones: {
      kh_zuoying: 'Zuoying HSR station',
      kh_lotus: 'Lotus Pond',
      kh_yancheng: 'Yancheng old quarter',
      kh_loveRiver: 'Love River',
      kh_formosa: 'Formosa Boulevard',
      kh_liuhe: 'Liuhe Night Market',
      kh_pier2: 'Pier-2 Art Center',
      kh_harbor: 'Kaohsiung Harbour',
    },
    objects: {
      kh_hsr: 'HSR station · Zuoying',
      kh_mrtZuoying: 'KMRT · Zuoying (R16)',
      kh_mrtFormosa: 'KMRT · Formosa Boulevard',
      kh_mrtYancheng: 'KMRT · Yanchengpu (O2)',
      kh_lotusView: 'Lotus Pond lookout',
      kh_dragon: 'Dragon and Tiger Pagodas',
      kh_dome: 'Dome of Light',
      kh_papaya: 'Papaya milk stand',
      kh_oyster: 'Oyster omelette stall',
      kh_squid: 'Grilled squid stall',
      kh_loveBoat: 'Love Boat tickets',
      kh_pier2: 'Pier-2 warehouse',
      kh_giants: 'Giant worker statues',
      kh_lrt: 'Light rail stop · Pier-2',
      kh_lrtHamasen: 'Light rail stop · Hamasen',
      kh_ferry: 'Cijin ferry',
      kh_icecream: 'Cijin ice cream cart',
      kh_tower85: '85 Sky Tower lookout',
    },
    npc: {
      kh_stationStaff: 'Station staff',
      kh_monk: 'Monk',
      kh_domeGuide: 'Dome guide',
      kh_papayaVendor: 'Papaya milk vendor',
      kh_oysterAuntie: 'Oyster omelette auntie',
      kh_boatman: 'Love Boat captain',
      kh_cyclist: 'Cyclist',
      kh_artist: 'Pier-2 artist',
      kh_fisher: 'Cijin fisherman',
      kh_surfer: 'Surfer',
      kh_kiteKid: 'Kite boy',
      kh_kiteGirl: 'Kite girl',
    },
    items: {} as Record<string, { name: string; desc: string }>,

    closed: 'The stall is closed. Liuhe Night Market wakes up at five in the afternoon!',
    kmrt: {
      name: 'KMRT',
      // English practice
      ask: 'Which exit is this, please?',
      text: 'The Kaohsiung MRT (高雄捷運): the Red Line runs north–south, the Orange Line east–west. They cross at Formosa Boulevard.',
      to: { zuoying: '🔴 Zuoying — HSR station & Lotus Pond', formosa: '🔴🟠 Formosa Boulevard — Dome of Light & Liuhe', yancheng: '🟠 Yanchengpu — Love River & Pier-2' },
      riding: 'Mind the gap! The train glides off under the city…',
    },
    lrt: {
      text: 'The Kaohsiung Circular Light Rail (高雄輕軌) was the first light rail in Taiwan (2015). It has no overhead wires: the trams charge at every stop in twenty seconds!',
      to: { pier2: '🚈 Ride to Pier-2 (C12)', hamasen: '🚈 Ride to Hamasen & the ferry (C14)' },
      ask: '❓ Why no wires?',
      riding: 'Ding ding! The green tram hums along the grass track.',
      q: 'Why does this tram have no overhead wires?',
      // English practice
      a: ['It charges its batteries at every stop.', 'It is pulled by horses.', 'It runs on wind power.'],
      right: 'Right! Supercapacitors charge in seconds while people get on and off.',
      wrong: 'Look at the roof when it stops: a little arm reaches up to charge…',
    },
    dome: {
      text: 'The Dome of Light (光之穹頂) is under your feet, in Formosa Boulevard station: 30 metres across, 4,500 pieces of coloured glass, the largest glass artwork in the world. It tells a story of water, earth, light and fire.',
      ask: '🌈 Learn a fact (English)',
      q: 'What is the Dome of Light made of?',
      // English practice
      a: ['Coloured glass — four thousand five hundred pieces.', 'Plastic bottles.', 'Paper lanterns.'],
      right: 'Yes! The Italian artist Narcissus Quagliata worked on it for four years.',
      wrong: 'Look at the colours shining through the shells above the stairs…',
    },
    dragon: {
      text: 'The Dragon and Tiger Pagodas (龍虎塔) stand on Lotus Pond. You walk IN through the dragon’s mouth and OUT through the tiger’s mouth — that turns bad luck into good luck!',
      ask: '🐉 Which way in? (English)',
      q: 'Which mouth do you walk in through?',
      // English practice
      a: ['In through the dragon, out through the tiger.', 'In through the tiger, out through the dragon.', 'It doesn’t matter.'],
      right: 'Exactly! Dragon in, tiger out — now you have good luck for the rest of the day.',
      wrong: 'Careful! The other way round brings bad luck. Dragons first…',
    },
    lotus: {
      text: 'Lotus Pond (蓮池潭) is a 42-hectare lake ringed with temples. In summer it is pink with lotus flowers. Across the water, the Xuantian Shangdi statue is 72 metres tall — the tallest water-standing god statue in the world.',
      look: '🔭 Look through the telescope',
      looked: 'Dragon and tiger, two pavilions, and a giant god with a sword standing on the water. A little egret flies past.',
      // English practice
      phrase: 'Look! A giant statue on the water!',
    },
    // English practice: food orders.
    food: {
      papaya: { vendor: 'Papaya milk, fresh and cold! Large or small?', ok: 'A large papaya milk, please.', bad: ['Papaya. Milk. Now.', 'Give me the orange one.'], done: 'Sweet, creamy and ice-cold — Kaohsiung in a cup. The vendor winks: “Best in Liuhe!”', price: 30 },
      oyster: { vendor: 'Oyster omelette! Hot off the griddle. With sweet sauce?', ok: 'Yes, please. One oyster omelette with sauce.', bad: ['Omelette! Fast!', 'Oysters. Mine.'], done: 'Crispy edges, chewy middle, fat oysters and sweet-spicy sauce. Delicious!', price: 35 },
      squid: { vendor: 'Grilled squid! Spicy or not spicy?', ok: 'Not spicy, please. One grilled squid.', bad: ['Squid. Give.', 'I want the whole sea.'], done: 'Smoky, chewy, brushed with soy and sesame. You eat it off the stick like everyone else.', price: 40 },
      icecream: { vendor: 'Cijin ice cream! Mango, peanut or taro?', ok: 'One mango ice cream, please.', bad: ['Ice. Cream. Mango.', 'I want all of them for free.'], done: 'Cold and fruity, with a sea breeze and a gull eyeing your cone. Perfect!', price: 25 },
    },
    boat: {
      text: 'The Love Boat (愛之船) cruises down Love River under the bridges. At night the banks light up pink, violet and blue.',
      buy: '🎫 Buy a ticket (English)',
      q: 'How do you ask for a ticket politely?',
      // English practice
      a: ['Two tickets for the Love Boat, please.', 'Boat. Ticket. Now.', 'Take me somewhere.'],
      right: 'You glide under the bridges. Palms sway, hearts glow on the lamp posts, and the captain waves at every other boat.',
      wrong: 'The captain smiles: “Could you say that more politely?”',
      price: 40,
      poor: 'You don’t have enough coins for the boat.',
    },
    pier2: {
      text: 'Pier-2 Art Center (駁二藝術特區): these brick warehouses stored sugar and fish meal for the port in the 1970s. Abandoned for years, they became studios, galleries and a skate plaza in 2006.',
      ask: '🎨 Learn a fact (English)',
      q: 'What were these buildings before they were an art centre?',
      // English practice
      a: ['Port warehouses for sugar and fish meal.', 'A train station.', 'A school.'],
      right: 'Right! Now the old rails run through the plaza and the walls are covered in murals.',
      wrong: 'Look at the big doors and the rails in the ground…',
    },
    giants: {
      text: 'The giant statues of Pier-2: a dock worker and a fisherwoman, bright and blocky, remembering the people who built the harbour.',
      pose: '💪 Pose like a giant',
      posed: 'Arms up, chin high! Tourists laugh and take your photo next to the giants.',
      // English practice
      phrase: 'The worker is strong. The fisherwoman is brave.',
    },
    ferry: {
      text: 'The Gushan–Cijin ferry (鼓山渡輪) crosses the harbour to Cijin island with its lighthouse, black-sand beach and seafood street. Scooters ride on board too!',
      ask: '⛴️ Learn a fact (English)',
      q: 'How long does the ferry to Cijin take?',
      // English practice
      a: ['About five minutes.', 'Two hours.', 'All day.'],
      right: 'Yes! Five minutes across the water — and the scooters go first.',
      wrong: 'Look across the harbour: you can see Cijin from here…',
    },
    tower: {
      text: 'The 85 Sky Tower (高雄85大樓) is 347 metres tall: two legs and a central tower, shaped like the character 高 (gāo, “tall”) — the first character of Kaohsiung. It was Taiwan’s tallest building until Taipei 101.',
      ask: '🏙️ Learn a fact (English)',
      q: 'Which Chinese character is the tower shaped like?',
      // English practice
      a: ['高 — “tall”, the first character of Kaohsiung.', '大 — “big”.', '山 — “mountain”.'],
      right: 'Right! Two legs and a tall middle, just like 高.',
      wrong: 'Look at its shape: two legs holding up one tall tower…',
    },

    talk: {
      kh_stationStaff: {
        intro: 'Welcome to Kaohsiung! The weather is sunny all year here. Can I help you find something?',
        q: 'How do you ask where the MRT is?',
        // English practice
        a: ['Excuse me, where is the MRT station?', 'MRT. Where.', 'Take me to the MRT!'],
        right: 'Very polite! The KMRT entrance is on the plaza, to your right.',
        wrong: 'Try starting with “Excuse me…”',
      },
      kh_domeGuide: {
        intro: 'Welcome to Formosa Boulevard! Down the stairs is the Dome of Light. Guess what it is for?',
        q: 'Which of these happens under the Dome of Light?',
        // English practice
        a: ['Weddings — couples get married under the glass!', 'Swimming races.', 'Football matches.'],
        right: 'Yes! Every year couples choose this station for their wedding photos.',
        wrong: 'Think of something romantic, with colours and light…',
      },
      kh_monk: [
        'Walk in through the dragon and out through the tiger. Slowly — there is no hurry at Lotus Pond.',
        'English practice: “Good morning.” — “Good morning. Peace be with you.”',
        'The lotus grows out of the mud and opens clean in the sun. That is why we love it.',
      ],
      kh_papayaVendor: [
        'Kaohsiung papayas are the sweetest — the sun does all the work!',
        'English practice: “Would you like ice in it?” — “Yes, please. Lots of ice!”',
        'My grandmother started this stand. Same recipe, same blender noise!',
      ],
      kh_oysterAuntie: [
        'Fresh oysters from the lagoon every morning. Crispy outside, soft inside!',
        'English practice: “Is it spicy?” — “Just a little.”',
        'Night market rule: eat, walk, eat again!',
      ],
      kh_boatman: [
        'English practice: “All aboard!” — that’s what I say when the boat is ready.',
        'Love River used to be dirty. Now people row, run and sing karaoke on its banks!',
        'Thirty minutes down the river and back. The bridges are lowest at the harbour.',
      ],
      kh_cyclist: [
        'English practice: “Passing on your left!”',
        'You can cycle from Love River all the way to the harbour and Pier-2 — flat the whole way.',
        'The palms along the river? They lean because the sea wind blows every afternoon.',
      ],
      kh_artist: [
        'I paint whales. Kaohsiung is a port city, the sea is everywhere here.',
        'English practice: “What are you painting?” — “A whale, and a tram, and the sun.”',
        'The old rails in the plaza carried sugar to the ships. Now skateboards roll over them.',
      ],
      kh_fisher: [
        'I live on Cijin. Five minutes by ferry, but it feels like another island.',
        'English practice: “Did you catch anything?” — “A big one! It got away.”',
        'When the big ships come in, the water rises — hold your hat!',
      ],
      kh_surfer: [
        'Cijin has waves in winter and a black-sand beach. Best sunsets in Taiwan!',
        'English practice: “Can you swim?” — “Yes, I can. Can you surf?”',
        'The ferry takes my board for free. Scooters pay a bit more.',
      ],
      kh_kiteKid: [
        'My kite is the dragon one! It has twelve tails.',
        'English practice: “Hold the string tight!” — “I’ve got it!”',
      ],
      kh_kiteGirl: [
        'The wind from the sea is perfect in the afternoon. Wait for it… now!',
        'English practice: “Look how high it is!” — “Higher than the 85 tower!”',
      ],
    },
  },
};
